import { useMutation } from "@tanstack/react-query";
import { createStudent as apiCreate } from "../../api/apiStudents";
import { useSnackbar } from "notistack"; import { useNavigate } from "react-router-dom"; import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useCreateStudent() { const navigate = useNavigate(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: createStudent, isPending, error } = useMutation({ mutationFn: (req) => apiCreate(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); navigate('/students'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { isPending, error, createStudent }; }
